export const mutations = {
  setFormData: function (state, newVal) {
    state.formData = { ...state.formData, ...newVal };
  },
  setToken: function (state, token) {
    state.access_Token = token;
  },
  setNavigation: function (state, navigation) {
    state.navigation = navigation;
  },
};
